import { useEffect } from "react";
import { FONTS_CONFIG, loadGoogleFonts, getFontConfig } from "../utils/fonts";

export const useCompanyFont = (fontKey) => {
  useEffect(() => {
    if (!fontKey || typeof fontKey !== 'string') {
      // Use default fallback
      const defaultConfig = FONTS_CONFIG.montserrat;
      document.documentElement.style.setProperty(
        "--company-font",
        defaultConfig.css
      );
      const verifyDefault = getComputedStyle(document.documentElement).getPropertyValue('--company-font');
      if (defaultConfig.googleFont) {
        loadGoogleFonts(['montserrat']);
      }
      return;
    }

    // Get font configuration
    const fontConfig = getFontConfig(fontKey);

    // Set CSS variable on root element
    document.documentElement.style.setProperty(
      "--company-font",
      fontConfig.css
    );

    // Verify the CSS variable was set
    const verifyValue = getComputedStyle(document.documentElement).getPropertyValue('--company-font');

    // Load Google Font if applicable
    if (fontConfig.googleFont) {
      loadGoogleFonts([fontKey]);
    }
  }, [fontKey]);
};
